import { ContractEs } from "./es-contract.model";

export class EsRequestOperations {
    public iconClass: string;
    public colorClass: string;

    constructor(
        public Channel: string,
        public ContactDetail: string,
        public Message: string,
        public ContractID: string,
        public ContractNumber: string,
        public CreationDate: string,
        public CustomerName: string,
        public DocumentEnabled: boolean,
        public ID: number,
        public LastInteractionDate: string,
        public Motive: string,
        public MotiveAcronym: string,
        public Status: string,
        public subject: string,
        public Target: string,
        public Type: string,
        public Service: string,
        public ServiceAcronym: string,
        public description: string,
        public DataOrigin: string,
        public Intervention: InterventionES,
        public Details: DetailES[] = [],
        public Scheduling?: SchedulingES,
        public Task?: TaskES,
        public Attachments: any[] = [],
        public ExternalCategory: string = null,
        public ObjectId: string = null,
        public FormContact: RequestsAndOperationsFormContactES[] = null,
        public selected: boolean = false,
        public ServiceId: string = null,
        public MotiveLevel1: string = null,
        public MotiveLevel2: string = null,
        public MotiveLevel3: string = null,
        public captchaToken: string = null,
        public category: string = null,
        public type: string = null,
        public subtype: string = null
    ) {
        this.setIconClass();
    }

    public setIconClass() {
        switch (this.Status) {
            case "pt.edp.edponline.es.support.help.E0005":
            case "pt.edp.edponline.es.support.help.E0006":
                this.iconClass = "icon-edponline-Bop-070";
                this.colorClass = "warning-title";
                break;
            case "pt.edp.edponline.es.serviceOrder.status.E0003":
            case "pt.edp.edponline.es.serviceOrder.status.E0005":
                this.iconClass = "icon-edponline-Bop-132";
                this.colorClass = "awaiting-title";
                break;
            case "pt.edp.edponline.es.serviceOrder.status.E0004":
                this.iconClass = "icon-edponline-Bop-008";
                this.colorClass = "awaiting-title";
                break;
            case "pt.edp.edponline.es.support.help.E0007":
            case "pt.edp.edponline.es.support.help.concluido":
            case "pt.edp.edponline.es.serviceOrder.status.E0006":
            case "pt.edp.edponline.es.serviceOrder.status.E0008":
                this.iconClass = "icon-edponline-Bop-072";
                this.colorClass = "success-title";
                break;
            case "pt.edp.edponline.es.support.help.E0003":
            case "pt.edp.edponline.es.serviceOrder.status.E0007":
            case "pt.edp.edponline.es.serviceOrder.status.E0009":
            case "pt.edp.edponline.es.serviceOrder.status.E0010":
            case "pt.edp.edponline.es.serviceOrder.status.E0011":
                this.iconClass = "icon-edponline-Bop-071";
                this.colorClass = "error-title";
                break;
            default:
                this.iconClass = "icon-edponline-Bop-132";
                this.colorClass = "awaiting-title";
        }
    }
}
export interface EsRequestOperationsDetail {
    accountId: string;
    caseId: string;
    caseNumber: string;
    category: string;
    contractId: string;
    description: string;
    origin: string;
    parentworkorderId: string;
    recordTypeId: string;
    startDate: string;
    status: string;
    subject: string;
    substatus: string;
    subtype: string;
    type: string;
    closeDate: string;
    translateStatus?: string;
    translateStartDate?: string;
    translateOrigin?: string;
    translateCloseDate?: string;
    translateSubtype?: string;
    translateType?: string;
    translateMonth?: string;
}

export interface RequestsAndOperationsFormContactES {
    label: string;
    labelTranslate: string;
    value: string;
}
export interface TaskES {
    type: string;
    status: string;
    description: string;
    scheduling: SchedulingES;
}
export interface SchedulingES {
    endDate: string;
    startDate: string;
    startTime?: string;
    endTime?: string;
}
export interface DetailES {
    label: string;
    value: string;
    labelTranslate: string;
}
export interface ITimeSlotES {
    from: string;
    to: string;
    label: string;
}

export class RequestsAndOperationsFileES {
    constructor(
        public name: string,
        public size: string,
        public modified: string,
        public mimeType: string,
        public base64: string = null,
        public id: number = Date.now(),
        public error: string = null
    ) {}
}

export interface InterventionES {
    name: string;
    description: string;
    hasScheduling: boolean;
    hasTracking: boolean;
    tasks: InterventionTasksES[];
    action: InterventionActionES;
}

export interface InterventionTasksES {
    id: number;
    description: string;
    duration: number;
    link: string;
    price: number;
    taskType: InterventionTasksTypeES[];
    title: string;
}

export interface InterventionTasksTypeES {
    id: number;
    code: string;
    name: string;
}

export interface InterventionActionES {
    code: string;
    description: string;
}

export interface IInterventionDateES {
    available: boolean;
    date: string;
    timeSlots: ITimeSlotES[];
}

/* export interface IEsRequestsOperationsFilter {
    id: number;
    name: string;
    urlName: string;
    allOptionsLabel: string;
    allSelected: boolean;
    options: FilterOption[];
    mobileCollapsable: boolean;
    isMobileFilter: boolean;
    hasOptionSelected: boolean;
    clicked: boolean;
} */

export class IEsRequestsOperationsFilter {
    constructor(
        public id: number,
        public name: string,
        public urlName: string,
        public allOptionsLabel: string,
        public allSelected: boolean,
        public options: FilterOption[],
        public mobileCollapsable: boolean = false,
        public isMobileFilter: boolean = false,
        public hasOptionSelected: boolean = false,
        public clicked: boolean = false
    ) {}
}

export interface FilterOption {
    id: number;
    name: string;
    acronym: string;
    selected: boolean;
    statusCode?: string[];
}

export interface ESRequestsOperationsList {
    contract: ContractEs;
    localSupportList: boolean;
}

export class ESRequestsOperationsFiltersFactory {
    static generateRequestsAndOperationsFilters(res) {
        if (!res) {
            return [];
        }
        const serviceOptions: FilterOption[] = [];
        res.filter(item => item.acronym !== null).map(item =>
            serviceOptions.push({
                id: item.id,
                name: item.name,
                acronym: item.acronym,
                selected: item.isSelected,
            })
        );
        const statusOptions: FilterOption[] = [
            {
                id: 1,
                name: "pt.edp.edponline.es.request.operations.filter.support.pending",
                acronym: "PENDING",
                selected: false,
            },
            {
                id: 2,
                name: "pt.edp.edponline.es.request.operations.filter.support.pending.edp",
                acronym: "PENDING_EDP",
                selected: false,
            },
            {
                id: 3,
                name: "pt.edp.edponline.es.request.operations.filter.support.closed",
                acronym: "RESOLVED",
                selected: false,
            },
            {
                id: 4,
                name: "pt.edp.edponline.es.request.operations.filter.support.cancelled",
                acronym: "CANCELED",
                selected: false,
            },
        ];

        const ftrService = new IEsRequestsOperationsFilter(
            1,
            "pt.edp.edponline.es.request.operations.filter.services.name",
            "Service",
            "pt.edp.edponline.benefits.filters.allCardSubtypes",
            false,
            serviceOptions,
            false,
            false,
            false
        );
        const ftrStatus = new IEsRequestsOperationsFilter(
            2,
            "pt.edp.edponline.es.request.operations.filter.status.name",
            "status",
            "pt.edp.edponline.benefits.filters.allCardSubtypes",
            false,
            statusOptions,
            false,
            false,
            false
        );

        return [ftrService, ftrStatus];
    }
}

export class ESRequestsAndOperationsFactory {
    static create(requestsAndOperations: EsRequestOperations) {
        return new EsRequestOperations(
            requestsAndOperations.Channel,
            requestsAndOperations.ContactDetail,
            requestsAndOperations.Message,
            requestsAndOperations.ContractID,
            requestsAndOperations.ContractNumber,
            requestsAndOperations.CreationDate,
            requestsAndOperations.CustomerName,
            requestsAndOperations.DocumentEnabled,
            requestsAndOperations.ID,
            requestsAndOperations.LastInteractionDate,
            requestsAndOperations.Motive,
            requestsAndOperations.MotiveAcronym,
            requestsAndOperations.Status,
            requestsAndOperations.subject,
            requestsAndOperations.Target,
            requestsAndOperations.Type,
            requestsAndOperations.Service,
            requestsAndOperations.ServiceAcronym,
            requestsAndOperations.description,
            requestsAndOperations.DataOrigin,
            requestsAndOperations.Intervention,
            requestsAndOperations.Details,
            requestsAndOperations.Scheduling,
            requestsAndOperations.Task,
            requestsAndOperations.Attachments,
            requestsAndOperations.ExternalCategory,
            requestsAndOperations.ObjectId,
            requestsAndOperations.FormContact
        );
    }
}
